import { Locale, TranslateFunc } from '@ha/intl';
import { countries as countriesList, Country } from 'ha/constants/Countries';
import { getDisplayNames } from 'ha/i18n/helpers';

export function getCountriesOptions(
  T: TranslateFunc,
  locale: Locale,
  countries: Country[] = countriesList,
) {
  const displayNames = getDisplayNames(locale);

  return [
    {
      value: '',
      title: T('Select country'),
      disabled: true,
    },
  ].concat(
    countries
      .map(country => ({
        value: country.code,
        title: displayNames.of(country.code) || country.name,
        disabled: false,
      }))
      .sort((countryA, countryB) =>
        countryA.title.localeCompare(countryB.title),
      ),
  );
}
